import { render, staticRenderFns } from "./cargoRow.vue?vue&type=template&id=bdc560ae"
import script from "./cargoRow.vue?vue&type=script&lang=js"
export * from "./cargoRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports